<template>
  <div class="detailContent">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('message.ideaDetail.back') }}</span>
    </div>
    <div class="header">
      <span class="title">{{ $t('message.ideaDetail.header') }}</span>
    </div>
    <div class="list">
      <div class="title">{{ $t('message.ideaDetail.module') }}</div>
      <div class="detail">{{ module }}</div>
    </div>
    <div class="list">
      <div class="title">{{ $t('message.ideaDetail.questionAndAnalysis') }}</div>
      <div class="detail">{{ content }}</div>
    </div>
    <div class="attach">
      <div class="title">{{ $t('message.ideaDetail.attachments') }}</div>
      <div class="detail">
        <Amplify v-for="(item, index) of attachList" :key="index" class="attachList" :type="item.type" :url="item.url"></Amplify>
      </div>
    </div>
    <div class="sysReply" v-for="item of replyContent" :key="item.id">
      <div class="title">{{ $t('message.ideaDetail.systemReply') }}</div>
      <div class="desc">{{ item.replyContent }}</div>
      <div class="detail" v-if="item.attachments.length > 0">
        <Amplify v-for="(itemAttach, index) of item.attachments" :key="index" class="attachList" :type="itemAttach.type" :url="itemAttach.url"></Amplify>
      </div>
      <div class="time">{{ item.createdAt }}</div>
    </div>
    <div class=""></div>
  </div>
</template>

<script>
import Amplify from '@/components/amplify/index.vue'
import { feedbackDetail } from '@/api/message.js'

export default {
  components: {
    Amplify
  },
  data() {
    return {
      module: '',
      content: '',
      attachList: [],
      replyContent: []
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    async getDetail() {
      const res = await feedbackDetail({ id: this.id })
      if (res.code === 200) {
        const data = res.data
        this.module = data.module
        this.content = data.content
        this.attachList = data.attachments
        this.replyContent = data.Replies
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getDetail()
  }
}

</script>

<style scoped lang="less">
.detailContent{
  padding: 18px 21px;
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.list{
  margin-top: 23px;
  width: 100%;
  .title{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
  }
  .detail{
    width: 100%;
    min-height: 38px;
    background: #FCFCFC;
    border-radius: 4px;
    border: 1px solid #D8DCE0;
    padding: 8px 20px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    margin-top: 12px;
  }
}
.attach{
  margin-top: 23px;
  width: 100%;
  .title{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
  }
  .detail{
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 12px;
    .attachList{
      width: 184px;
      height: 104px;
      margin-right: 12px;
      background: #FCFCFC;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
    }
  }
}
.sysReply{
  width: 100%;
  background: #F7F8F9;
  padding: 12px;
  margin-top: 23px;
  .title{
    font-weight: 600;
    font-size: 14px;
    color: #6B738C;
  }
  .desc{
    margin-top: 12px;
    font-weight: 400;
    font-size: 14px;
    color: #424652;
  }
  .time{
    font-weight: 400;
    font-size: 11px;
    color: #A1A1A1;
    margin-top: 12px;
  }
  .detail{
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 12px;
    .attachList{
      width: 184px;
      height: 104px;
      margin-right: 12px;
      background: #FCFCFC;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
    }
  }
}
</style>
